import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { AssetDeletionReason } from "../../schema.generated";

export interface DeleteAssetMutationVariables {
  id: string;
  deletionReason?: AssetDeletionReason;
  deletionReasonText?: string;
}

export interface DeleteAssetMutationResult {
  deleteAsset: {
    success: boolean;
  };
}

export const DELETE_ASSET_MUTATION = gql`
  mutation deleteAsset(
    $id: ID!
    $deletionReason: AssetDeletionReason
    $deletionReasonText: String
  ) {
    deleteAsset(
      assetId: $id
      deletionReason: $deletionReason
      deletionReasonText: $deletionReasonText
    ) {
      success
    }
  }
`;

export const useDeleteAssetMutation = (
  options?: MutationHookOptions<
    DeleteAssetMutationResult,
    DeleteAssetMutationVariables
  >
) =>
  useMutation<DeleteAssetMutationResult, DeleteAssetMutationVariables>(
    DELETE_ASSET_MUTATION,
    options
  );
